// ------------------------------------
// Constants

// ------------------------------------
export const initialState: State.Apprentice = {
  accountId: '',
  apprenticePathway: '',
  isLoading: true,
};
